import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmailCycleNamesRPC } from "./getEmailCycleNamesRPC";

export class GetEmailCycleNamesRPCClientImpl extends GetEmailCycleNamesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmailCycleNamesRPC.Request): Promise<LeoRPCResult<GetEmailCycleNamesRPC.Response, GetEmailCycleNamesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetEmailCycleNames",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmailCycleNamesRPC.ResponseDTO,
      GetEmailCycleNamesRPC.Errors.ErrorsDTO,
      GetEmailCycleNamesRPC.Response,
      GetEmailCycleNamesRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetEmailCycleNames",
      GetEmailCycleNamesRPC.Response.fromDTO,
      GetEmailCycleNamesRPC.Errors.fromDTO
    );
  }
}
